import React, { useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import { PageHeader } from "@ant-design/pro-components";
import { Layout, Breadcrumb, Button, ConfigProvider, Card, Tooltip, Tag } from "antd";
import { ProTable } from "@ant-design/pro-components";
import { useNavigate, useLocation } from "react-router-dom";
import ptBRIntl from "antd/lib/locale/pt_BR";
import moment from "moment";
import "moment/locale/pt-br";
import "reactjs-popup/dist/index.css";


import { userApi } from "../../../services/actions/users";
import PermissionWrapperComponent from "../../../components/PermissionWrapperComponent";

/**
 * Utils
 */
import { usePersistentFilters } from "utils/use-persistents-filters";
import { defaultTablePagination } from "utils/table-pagination";


const filterConfig = [
    { field: 'firstName', queryParam: 'name', localKey: 'name', type: 'text' },
    { field: 'lastName', queryParam: 'lastname', localKey: 'lastname', type: 'text' },
    { field: 'email', queryParam: 'email', localKey: 'email', type: 'text' },
    { field: 'username', queryParam: 'username', localKey: 'username', type: 'text' }
]


function AllUsers({ user }) {
    const navigate = useNavigate();

    // 
    const location = useLocation();

    // 
    const actionRef = useRef();
    const formRef = useRef();

    // 
    const {initialValues, onSubmitFilters, onReset} = usePersistentFilters(filterConfig, actionRef, formRef, location, navigate);

    const columns = [
        {
            sorter: false,
            title: "Nome",
            dataIndex: "firstName",
            key: "firstName",
            width: "auto",
            ellipsis: true,
            valueType: "text",
            fieldProps: {
                placeholder: "",
            },
        },
        {
            sorter: false,
            title: "Sobrenome",
            dataIndex: "lastName",
            key: "lastName",
            width: "auto",
            ellipsis: true,
            valueType: "text",
            responsive: ["md"],
            fieldProps: {
                placeholder: "",
            },
        },
        {
            sorter: false,
            title: "E-mail",
            dataIndex: "email",
            key: "email",
            valueType: "text",
            fieldProps: {
                placeholder: "",
            },
            width: "auto",
            ellipsis: true,
        },
        {

            sorter: true,
            title: "Usuário",
            dataIndex: "username",
            key: "username",
            valueType: "text",
            responsive: ["md"],
            fieldProps: {
                placeholder: "",
            },
            width: "auto",
            ellipsis: true
        },
        {
            sorter: false,
            search: false,
            title: "Status",
            dataIndex: "active",
            key: "active",
            width: "auto",
            render: (dom, record) => (
                record.active === false
                    ? <Tag color="red">Desativado</Tag>
                    : <Tag color="green">Ativo</Tag>
            ),
        },
        {
            sorter: false,
            title: "Criado em",
            dataIndex: "createdAt",
            key: "createdAt",
            responsive: ["lg"],
            render: (dom, entity, index, action, schema) => {
                if (action) {
                    return moment(entity[schema.dataIndex]).format("DD/MM/YYYY HH:mm:ss");
                }
            },
            width: "auto",
            ellipsis: true,
            search: false,
        },
        {
            sorter: false,
            title: "Atualizado em",
            dataIndex: "updatedAt",
            key: "updatedAt",
            responsive: ["lg"],
            render: (dom, entity, index, action, schema) => {
                if (action) {
                    return moment(entity[schema.dataIndex]).format("DD/MM/YYYY HH:mm:ss");
                }
            },
            width: "auto",
            ellipsis: true,
            search: false,
        },
    ];
    const company = useSelector(state => state.user.company);

    return (<React.Fragment>
        <Card>
            <ConfigProvider locale={ptBRIntl}>
                {company !== null && <ProTable
                    rowKey="_id"
                    type="table"
                    columnsState={{
                        persistenceKey: "clm-pro-table-users-all",
                        persistenceType: "localStorage",
                    }}
                    pagination={defaultTablePagination}
                    params={initialValues}
                    formRef={formRef}
                    actionRef={actionRef}
                    onSubmit={onSubmitFilters}
                    onReset={onReset}
                    request={async (params = {}, sorter, filter) => {
                        const {
                            firstName = null,
                            lastName = null,
                            email = null,
                            username = null,
                        } = params
                        const data = {};
                        if (firstName) {
                            data['firstName'] = firstName;
                        }
                        if (lastName) {
                            data['lastName'] = lastName;
                        }
                        if (email) {
                            data['email'] = email;
                        }
                        if (username) {
                            data['username'] = username;
                        }

                        if (Object.keys(sorter || {}).length > 0) {
                            const field = Object.keys(sorter)[0];
                            if (field && sorter[field]) {
                                data['orderByField'] = field;
                                data['orderBySort'] = sorter[field] === 'ascend' ? 'ASC' : 'DESC';
                            }
                        }

                        const response = await userApi.getAll({
                            ...data,
                            page: params.current,
                            perPage: params.pageSize,
                            unitId: company.unitId
                        });

                        return {
                            data: response.data.users,
                            success: true,
                            total: response.data.total,
                        };
                    }}
                    columns={columns}
                    dateFormatter={"number"}
                    scroll={{ x: true }}
                    style={{ padding: 0 }}
                    onRow={(record) => ({
                        onClick: () => navigate(`/usuarios/editar/${record.uuid}`),
                        style: { cursor: "pointer" },
                    })}
                    toolbar={{
                        actions: [
                            <PermissionWrapperComponent permissions={['CREATE_USER']}>
                                <Button type="primary"
                                    onClick={() =>
                                        navigate(`/usuarios/novo`)
                                    }>
                                    Adicionar
                                </Button>
                            </PermissionWrapperComponent>

                        ],
                    }}
                />}
            </ConfigProvider>
        </Card>
    </React.Fragment>);
}

const mapStateToProps = ({ session }) => ({
    user: session.user,
});

export default connect(mapStateToProps)(AllUsers);
